module.exports = __webpack_public_path__ + "assets/img/Arty_Paris_001.a86ce213-ps.jpg";